import PropTypes from 'prop-types';
import React from 'react';
import { useRequestData, useLabels } from 'wsm-common-data';
import { removeFilter } from '../../utilities/filters';

const FilterItem = ({
	filterId,
	filterLabel,
	value,
	label,
	showRemoveButton
}) => {
	const labels = useLabels();
	const { widgetName, windowId } = useRequestData();

	// Add the facet name as a prefix to interior color and exterior color filters. Example: "Exterior Color: Gold"
	let formattedLabel = label;
	let formattedValueInAriaLabel = label;
	if (
		filterId === 'normalInteriorColor' ||
		filterId === 'normalExteriorColor'
	) {
		const prefix = `${filterLabel}: `;
		// Check whether the label already contains the prefix.
		// See GitHub issue https://ghe.coxautoinc.com/DDC-WebPlatform/ws-inv-filters/issues/152
		if (label?.startsWith(prefix)) {
			// eslint-disable-next-line prefer-destructuring
			formattedValueInAriaLabel = label.split(prefix)[1];
		} else {
			formattedLabel = `${prefix}${label}`;
		}
	}

	return (
		<button
			type="button"
			className="pill chip chip-default chip-condensed facet-filter"
			onClick={(e) =>
				showRemoveButton
					? removeFilter({
							e,
							id: filterId,
							value,
							widgetName,
							windowId
					  })
					: {}
			}
			aria-label={labels
				.get('FILTER_VALUE_CLICK_TO_REMOVE')
				.replace('{filter}', filterLabel)
				.replace('{value}', formattedValueInAriaLabel)}
		>
			{formattedLabel}{' '}
			{showRemoveButton ? (
				<i className="ddc-icon ddc-icon-remove2" />
			) : null}
		</button>
	);
};

FilterItem.propTypes = {
	filterId: PropTypes.string.isRequired,
	filterLabel: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	showRemoveButton: PropTypes.bool
};

FilterItem.defaultProps = {
	showRemoveButton: true
};

export default FilterItem;
